import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useAppDispatch } from 'Context/AppContext/AppContext'
import {
  UPDATE_NONPROFIT_ORG_CONFIG,
  UPDATE_NONPROFIT_ORG_CONFIG_ERRORED,
  UPDATE_NONPROFIT_ORG_CONFIG_LOADING,
} from 'TypeDefs/AppContext'
import { useLazyQuery, makeVar } from '@apollo/client'
import GET_NONPROFIT_ORG_CONFIG_QUERY from 'Apollo/Queries/GetNonprofitOrgConfig'
import { ReturnedNonprofitOrg } from 'TypeDefs/NonprofitOrgConfig'

export const nonprofitOrgIdVar = makeVar<number | null>(null)

const useNonprofitOrganizationConfig = () => {
  const { user } = useAuth0()
  const email = user?.email

  const dispatch = useAppDispatch()
  const [getNonprofitOrgConfig, { loading }] =
    useLazyQuery<ReturnedNonprofitOrg>(GET_NONPROFIT_ORG_CONFIG_QUERY, {
      context: { clientName: 'batched' },
      onCompleted: (data) => {
        dispatch({
          type: UPDATE_NONPROFIT_ORG_CONFIG,
          nonprofitOrgConfig: data.nonprofitOrg,
        })

        nonprofitOrgIdVar(data.nonprofitOrg.orgId)
      },
      onError: () => {
        dispatch({
          type: UPDATE_NONPROFIT_ORG_CONFIG_ERRORED,
          errored: true,
        })
      },
    })

  useEffect(() => {
    dispatch({
      type: UPDATE_NONPROFIT_ORG_CONFIG_LOADING,
      loading,
    })
  }, [loading, dispatch])

  useEffect(() => {
    if (email) {
      getNonprofitOrgConfig()
    }
  }, [getNonprofitOrgConfig, email])
}

export default useNonprofitOrganizationConfig
